/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import { Logo } from "./Header";

export default function Footer({ onSampleReport, onScrollTo }) {
  const productCol = [
    ["How it works", "how"],
    ["What's included", "included"],
    ["Pricing", "pricing"],
    ["Sample Report", "__sample"],
  ];
  const companyCol = [
    ["About", "about"],
    ["FAQ", "faq"],
    ["Contact", "contact"],
  ];
  return (
    <footer className="border-t border-black/5 bg-white" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo />
            <p className="text-sm text-charcoal-500 mt-4 leading-relaxed max-w-xs">
              Monthly Operations Checkups for Small Nonprofits. We watch the little things so you don't have to.
            </p>
          </div>
          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-charcoal-400 mb-4">Product</p>
            <ul className="space-y-2.5">
              {productCol.map(([label, target]) => (
                <li key={label}>
                  <button
                    onClick={() => (target === "__sample" ? onSampleReport() : onScrollTo(target))}
                    className="text-sm text-charcoal-600 hover:text-charcoal-900 transition-colors"
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-charcoal-400 mb-4">Company</p>
            <ul className="space-y-2.5">
              {companyCol.map(([label, target]) => (
                <li key={label}>
                  <button
                    onClick={() => onScrollTo(target)}
                    className="text-sm text-charcoal-600 hover:text-charcoal-900 transition-colors"
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-mono uppercase tracking-[0.15em] text-charcoal-400 mb-4">Legal</p>
            <ul className="space-y-2.5">
              <li>
                <Link to="/privacy" className="text-sm text-charcoal-600 hover:text-charcoal-900 transition-colors" data-testid="footer-link-privacy">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-charcoal-600 hover:text-charcoal-900 transition-colors" data-testid="footer-link-terms">
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-black/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-charcoal-400 font-mono">© {new Date().getFullYear()} Mission Watch. All rights reserved.</p>
          <p className="text-xs text-charcoal-400">Operational monitoring only — not legal, tax, or accounting advice.</p>
        </div>
      </div>
    </footer>
  );
}
